import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'
import { WorkflowStage } from '../types'

const isLocalUUID = (s: string) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s)

const isValidStage = (s: string) => Object.values(WorkflowStage).includes(s as WorkflowStage)

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('../components/Dashboard/TemplateDashboard.vue'),
    },
    {
      path: '/:templateId/:stage',
      name: 'workflow-stage',
      component: () => import('../components/Pages/WorkflowPage.vue'),
      beforeEnter: (to: RouteLocationNormalized) => {
        const stage = to.params.stage as string
        if (!isValidStage(stage)) {
          return { name: 'dashboard' }
        }
      },
    },
    {
      path: '/:id',
      name: 'workflow-id',
      component: () => import('../components/Pages/WorkflowPage.vue'),
      beforeEnter: (to: RouteLocationNormalized) => {
        const id = to.params.id as string
        // If it's a valid stage name alone (no template), treat as new workflow
        if (isValidStage(id)) return
        // Otherwise it's a template ID — let the page resolve it
        if (!isLocalUUID(id)) return // remote IDs handled by the page
      },
    },
    {
      // Catch-all → dashboard
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
})

export default router
